<template>
  <div class="spinner-container">
    <div class="spinner" />
  </div>
</template>

<style>
.spinner-container {
  padding: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.spinner {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  position: relative;
  animation: spin 1.5s linear infinite;
}

.spinner::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background: conic-gradient(
    from 0deg,
    transparent 0%,
    transparent 15%,
    #5D7059 35%,
    #5D7059 65%,
    transparent 85%,
    transparent 100%
  );
  animation: fadeSpinner 2s linear infinite;
  mask: radial-gradient(transparent 65%, black 66%);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fadeSpinner {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
</style>
